import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const WHATSAPP_NUMBER = "+14313345083";
export const EMAIL = "contactjosmart1@gmail.com";

export const getWhatsAppLink = (message = "") => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER.replace('+', '')}${message ? `?text=${encodedMessage}` : ''}`;
};

export const getEmailLink = (subject = "", body = "") => {
  const params = new URLSearchParams();
  if (subject) params.append('subject', subject);
  if (body) params.append('body', body);
  return `mailto:${EMAIL}${params.toString() ? `?${params.toString()}` : ''}`;
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
};

export const getStatusLabel = (status) => {
  const labels = {
    available: 'Disponible',
    coming_soon: 'Bientôt disponible',
    in_preparation: 'En préparation'
  };
  return labels[status] || status;
};

export const getFormTypeLabel = (type) => {
  const labels = {
    project: 'Projet',
    demo: 'Démo',
    idea: 'Idée',
    product: 'Produit',
    contact: 'Contact'
  };
  return labels[type] || type;
};

export const getSubmissionStatusLabel = (status) => {
  const labels = {
    new: 'Nouveau',
    read: 'Lu',
    processed: 'Traité'
  };
  return labels[status] || status;
};
